<template>
	<div class="import-shop-products">
		<b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
		<h1>Import Shop Products</h1>

		<p class="description">
			This will import products and stocks to selected shop. Please refer to shop_product_import.csv provided.
		</p>

		<b-field class="file">
			<b-upload v-model="file" ref="file">
				<a class="button is-primary">
					<b-icon icon="upload"></b-icon>
					<span>Select a file</span>
				</a>
			</b-upload>
			<span class="file-name" v-if="file">
				{{ file.name }}
			</span>
		</b-field>

		<div class="button-container">
			<div class="big-button" @click="uploadFile()">
				Upload CSV File
			</div>
		</div>

		<div class="import-shop-products-settings" v-if="this.fileUpload !== null">
			<div v-if="this.shops.length > 0">
				<b-autocomplete
					v-model="shopsSuggestions"
					:data="filteredShops"
					:open-on-focus="true"
					placeholder="Shop"
					field="name"
					@select="option => (selectedShop = option)"
					class="shopAutoComplete"
				>
					<template slot="empty">No results found</template>
				</b-autocomplete>

				<div class="button-container">
					<div class="big-button" @click="importShopProducts()">
						Import Shop Products
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ImportShopProducts',
	data: () => ({
		isLoading: false,
		file: null,
		fileUpload: null,
		shops: [],
		shopsSuggestions: '',
		selectedShop: null
	}),

	computed: {
		filteredShops() {
			return this.shops.filter(option => {
				return (
					option.name
						.toString()
						.toLowerCase()
						.indexOf(this.shopsSuggestions.toLowerCase()) >= 0
				)
			})
		}
	},

	mounted: async function() {
		await this.getShops()
	},

	watch: {},

	methods: {
		// Import Shop Products
		importShopProducts: async function() {
			this.isLoading = true

			const data = {
				file: this.fileUpload._id,
				shop: this.selectedShop._id
			}

			const apiImportShopProducts = await this.$api.importShopProducts({
				data
			})

			this.isLoading = false

			if (apiImportShopProducts !== undefined) {
				this.$swal.fire('Products are imported to shop!')
			}
		},

		// Get list of shops
		getShops: async function() {
			const apiGetShops = await this.$api.getShops({})

			this.shops = apiGetShops.data.list
		},

		uploadFile: async function() {
			const data = {
				type: 'csv',
				file: this.file
			}

			const apiFileUpload = await this.$api.fileUpload({ data })

			if (apiFileUpload !== undefined) {
				// console.log(apiFileUpload.data);

				this.fileUpload = apiFileUpload.data
			}
		}
	}
}
</script>

<style scoped>
@import '../styles/GeneralStyles.css';
</style>
